'use client';

import {forwardRef, useContext} from 'react';
import styled from '@emotion/styled';

import {SizeTokenValue} from 'common';
import {ArrowDownIcon, ArrowUpIcon} from 'icons';
import {SelectContext} from 'Select/Select';

import {EditableInput} from './EditableInput';
import {ReadonlyInput} from './ReadonlyInput';

import type {InputProps} from 'Input';

const EndAdornment = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const SelectInput = forwardRef<HTMLInputElement, Omit<InputProps, 'value' | 'onChange'>>((props, ref) => {
  const context = useContext(SelectContext);

  const Component = context.filter ? EditableInput : ReadonlyInput;

  const Chevron = context.isOpen ? ArrowUpIcon : ArrowDownIcon;

  const endAdorment = (
    <EndAdornment>
      {props.endAdornment}
      <Chevron size={SizeTokenValue.Small} />
    </EndAdornment>
  );

  return <Component ref={ref} {...props} endAdornment={endAdorment} />;
});
